import axios from 'axios'

import { getBaseApiURL } from '@/utils/env'

export const publicClient = axios.create({
  baseURL: getBaseApiURL(),
  headers: {
    'Content-Type': 'application/json',
  },
})
